import React, { useState } from "react";

const Supplier = () => {
  return (
    <>
      <div className="row pb-3">
        <div className="col-md-12">
          <div className="card px-3 py-2">
            <div className="row">
              <div className="col-md-12 ">
            <h6>Supplier / Exporter</h6>
            </div>
            <div className=" col-md-4">
                            <label className="form-label">
                            Name
                            </label>
                            <select className='form-control form-control-sm' id="prepaidCollect" >
                                <option value="Prepaid" selected >-</option>
                                <option value="Collection" >-</option>
                            </select>
                        </div>
            <div className=" col-md-4 ">
                            <label className="form-label">
                            City
                            </label>
                            <input type="text" className="form-control form-control-sm" />
                        </div>
            <div className=" col-md-4 ">
                            <label className="form-label">
                            Country
                            </label>
                            <input type="text" className="form-control form-control-sm" />
                        </div>
                        <hr className="mt-2" />
              <div className="col-md-12">
            <h6>Seller</h6>
            </div>
            <div className=" col-md-4 ">
                            <label className="form-label">
                            Name
                            </label>
                            <select className='form-control form-control-sm' id="prepaidCollect" >
                                <option value="Prepaid" selected >-</option>
                                <option value="Collection" >-</option>
                            </select>
                        </div>
            <div className=" col-md-4 ">
                            <label className="form-label">
                            City
                            </label>
                            <input type="text" className="form-control form-control-sm" />
                        </div>
            <div className=" col-md-4 ">
                            <label className="form-label">
                            Country
                            </label>
                            <input type="text" className="form-control form-control-sm" />
                        </div>
                        <hr className="mt-2" />
              <div className="col-md-12">
            <h6>Broker</h6>
            </div>
            <div className=" col-md-4 ">
                            <label className="form-label">
                            Name
                            </label>
                            <select className='form-control form-control-sm' id="prepaidCollect" >
                                <option value="Prepaid" selected >-</option>
                                <option value="Collection" >-</option>
                            </select>
                        </div>
            <div className=" col-md-4 ">
                            <label className="form-label">
                            City
                            </label>
                            <input type="text" className="form-control form-control-sm" />
                        </div>
            <div className=" col-md-4 ">
                            <label className="form-label">
                            Country
                            </label>
                            <input type="text" className="form-control form-control-sm" />
                        </div>
                        <hr className="mt-2" />
              <div className="col-md-12">
            <h6>Actual Seller / Third Party</h6>
            </div>
            <div className=" col-md-4">
                            <label className="form-label">
                            Name
                            </label>
                            <select className='form-control form-control-sm' id="prepaidCollect" >
                                <option value="Prepaid" selected >-</option>
                                <option value="Collection" >-</option>
                            </select>
                        </div>
            <div className=" col-md-4 ">
                            <label className="form-label">
                            City
                            </label>
                            <input type="text" className="form-control form-control-sm" />
                        </div>
            <div className=" col-md-4 ">
                            <label className="form-label">
                            Pin 
                            </label>
                            <input type="text" className="form-control form-control-sm" />
                        </div>
            <div className=" col-md-4 ">
                            <label className="form-label">
                            Country
                            </label>
                            <input type="text" className="form-control form-control-sm" />
                        </div>
            <div className=" col-md-4 ">
                            <label className="form-label">
                            State
                            </label>
                            <input type="text" className="form-control form-control-sm" />
                        </div>
                        <div className="col-md-8 mt-3">
                          <div className="d-flex">
                          <input type="checkbox"/>
                          <label className="form-label ms-2">
                          Use Supplier / Exporter as default manufacturer
                            </label>
                          </div>
                        </div>
                        <div className="col-md-4 mt-3">
                        <button className="btn btn-primary text-xs" type="submit">
                        Create New Organization
                        </button>
                        </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default Supplier;
